import React, { useState, useEffect, useRef } from "react";
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import {Tooltip, IconButton, Snackbar, InputAdornment, Select, MenuItem, ListSubheader} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Button from '@mui/material/Button';
import HyperLink from '@mui/material/Link';
import OtpInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { useAuth } from '../util/AuthContext';
// import '../assets/styles/global.css';

import { GenerateOtp, ValidateOtp, UniversityDetails, ValidateCaptcha, ValidateToken, countryCode as countryCodeApi } from '../util/apiUrl';
import { injectTagForUniv } from '../util/gtm';

const year = dayjs().subtract(15, 'year');

export default function LoginContainer() {
    // const univID = 45;

    const [univID, setUnivID] = useState(null);
    const [captchaEnable, setCapchaEnable] = useState(0);
    const [captchaDetails, setCaptchaDetails] = useState(null);
    const [validateOtpData, setValidateOtpData] = useState(null);
    const [captchaValue, setCaptchaValue] = useState(null);
    // const [otpVerified, setOtpVerified] = useState(false);
    // const [captchaVerified, setCaptchaVerified] = useState(false);
    const [state, setState] = useState({
        mobileView: false,
    });
    const [universityFlags, setUniversityFlags] = useState([])
    const [isAdmissionAuthEnabled, SetIsAdmissionAuthEnabled] = useState(null);
    const [otpResponse, setOtpResponse] = useState(null);
    const [tokenData, setTokenData] = useState(null);
    const [tokenValidationData, setTokenValidationData] = useState(null);
    const [token, setToken] = useState('');
    const [tooltipTitle, setTooltipTitle] = useState('Copy');
    const [tempOtp, setTempOtp] = useState("");
    const [timeout, setTimeout] = useState(null);
    const [countdown, setCountdown] = useState(120);
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [countryCodeList, setCountryCodeList] = useState([]);
    const [selectedCountryCode, setSelectedCountryCode] = useState('');
    const [otpSource, setOtpSource] = useState('mobile');
    const [countrySearch, setCountrySearch] = useState('');
    const [showEmailOtpFallback, setShowEmailOtpFallback] = useState(false);
    const [showEmailField, setShowEmailField] = useState(false);
    const [sendOtpAttempt, setSendOtpAttempt] = useState(0);
    const mobileFieldRef = useRef(null);
    const [mobileFieldWidth, setMobileFieldWidth] = useState(0);

    // To set error message
    const [nameErrorMessage, setNameErrorMessage] = useState('')
    const [tokenErrorMessage, setTokenErrorMessage] = useState('')
    const [mobileErrorMessage, setMobileErrorMessage] = useState('')
    const [emailErrorMessage, setEmailErrorMessage] = useState('')
    const [dateErrorMessage, setDateErrorMessage] = useState('')
    const [otpErrorMessage, setOtpErrorMessage] = useState(null)
    const [captchaErrorMessage, setCaptchaErrorMessage] = useState(null)
    const [snackbarMessage, setSnackbarMessage] = useState('');

    // To set fields date, age, otp field
    const [selectedDate, setSelectedDate] = useState(null);
    const [otp, setOtp] = useState('');

    // Check for responsive
    const { mobileView } = state;
    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 900
                ? setState((prevState) => ({ ...prevState, mobileView: true }))
                : setState((prevState) => ({ ...prevState, mobileView: false }));
        };

        setResponsiveness();
        window.addEventListener("resize", () => setResponsiveness());

        return () => {
            window.removeEventListener("resize", () => setResponsiveness());
        }
    }, []);

    useEffect(() => {
        const importCSS = async () => {
            if (mobileView) {
                const module = await import('../assets/styles/mobile/global.css');
            } else {
                const module = await import('../assets/styles/global.css');
            }
        };

        importCSS();

    }, [mobileView]);

    useEffect(() => {
        if (sessionStorage.length > 0) {
            sessionStorage.removeItem('dateOfBirth')
            sessionStorage.removeItem('CourseId')
            sessionStorage.removeItem('source')
            sessionStorage.removeItem('enquiryId')
            sessionStorage.removeItem('CategoryId')
            sessionStorage.removeItem('mobileNo')
            sessionStorage.removeItem('loggedInUser')
            sessionStorage.removeItem('name')
            sessionStorage.removeItem('lastActiveSection')
            sessionStorage.removeItem('univID')
            sessionStorage.removeItem('admissionId')
            sessionStorage.removeItem('admissionStage')
            localStorage.removeItem('RenderFromPreview')
        }
    }, [])

    const UniversityUrl = window.location.origin;

    useEffect(() => {
        const fetchData = async () => {
            let url = `${UniversityDetails}?UmsUniversityUrl=${UniversityUrl}`;
            if(UniversityUrl === 'http://localhost:3001'){
                url = `${UniversityDetails}?UmsUniversityUrl=https://admission.teamleaseedtech.com`
            }
            try{
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                    'Content-Type': 'application/json',
                    },
                    // body: JSON.stringify({ UmsUniversityUrl:UniversityUrl }),
                });
                if(response.ok){
                    const data = await response.json();
                    sessionStorage.setItem("univID",data.data[0].UnvId);
                    setUnivID(data.data[0].UnvId)
                    setCapchaEnable(data.data[0].LoginCaptchaEnable)
                    setUniversityFlags(data.data[0].UniversityFlags)

                    if (Number(data.data[0]?.UnvId) !== 136) {
                        injectTagForUniv(data.data[0]?.UnvId);
                    }
                }else{
                    console.log("otp not generated")
                }
            }catch(error){
                console.log(error);
            }
        };

        if(UniversityUrl !== null){
            fetchData();
        }

    }, [UniversityUrl]);

    useEffect(() => {
        const fetchCountryCodes = async () => {
            try {
                const response = await fetch(countryCodeApi, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.ok) {
                    const result = await response.json();
                    const list = Array.isArray(result?.data) ? result.data : (Array.isArray(result) ? result : []);
                    setCountryCodeList(list);
                    if (list.length > 0) {
                        const defaultItem = list.find(
                            c => c.isDefault === 1 || c.IsDefault === 1 || c.isDefault === true
                        );
                        const initial = defaultItem
                            || list.find(c => String(getCC(c)).replace('+', '') === '91')
                            || list[0];
                        setSelectedCountryCode(String(getCC(initial)));
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchCountryCodes();
    }, []);

    useEffect(() => {
        if (Number(univID) === 136 && countryCodeList.length > 0) {
            injectTagForUniv(univID);
        }
    }, [univID, countryCodeList]);

    // Helpers to read country fields tolerantly across possible API shapes
    const getCC = (c) => c?.countryCode ?? c?.CountryCode ?? c?.code ?? c?.Code ?? '';
    const getCN = (c) => c?.countryName ?? c?.CountryName ?? c?.name ?? c?.Name ?? '';
    const getML = (c) => Number(c?.mobileNoLength ?? c?.MobileNoLength ?? c?.mobileLength ?? c?.MobileLength ?? c?.length ?? c?.Length ?? 10) || 10;

    const selectedCountry = countryCodeList.find(c => String(getCC(c)) === String(selectedCountryCode));
    const expectedMobileLength = selectedCountry ? getML(selectedCountry) : 10;
    const isIndia = String(selectedCountryCode).replace('+', '') === '91';

    // const isAdmissionAuthEnabled = universityFlags.find((flag) => flag.Key === "AdmissionAuthentication");

    useEffect(() => {
        if(universityFlags.length > 0){
            const admissionAuthEnabled = universityFlags.find((flag) => flag.Key === "AdmissionAuthentication");
            SetIsAdmissionAuthEnabled(admissionAuthEnabled.Value)
        }

    },[universityFlags])


    // useEffect(() => {
    //     setUnivID(45)
    //     sessionStorage.setItem("univID", 45);
    // }, [])

    


    // Validation of date field
    const handleDateChange = (date) => {
        setSelectedDate(date);
        setDateErrorMessage('');
        // calculateAge(date);
    };

    function formatDate(selectedDate) {
        const d = new Date(selectedDate);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    var dob = formatDate(selectedDate);

    const differenceInYears = (today, birthDate) => {
        let calculatedAge = today.getFullYear() - birthDate.getFullYear();
        let monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            calculatedAge--;
        }
        return calculatedAge;
    }

    // To set name and mobile number field
    const [inpVal, setInpVal] = useState({
        full_name: "",
        mobile: "",
        email: "",
        token_input: ""

    })
    const mobileNo = inpVal.mobile

    // Validation of name and mobile number   
    const check = (event) => {
        const { value, name } = event.target;
        setInpVal((prevInpVal) => ({
            ...prevInpVal,
            [name]: value
        }));

        if (name === 'full_name') {
            let regex = /^[A-Za-z\s'-]+$/;
            if (!regex.test(value.trim())) {
                setNameErrorMessage('Enter a valid full name');
            } else {
                setNameErrorMessage('');
            }
        }
        if (name === 'mobile') {
            const newValue = event.target.value.replace(/[^\d]/g, '').replace('e', '');

            const trimmedValue = newValue.slice(0, expectedMobileLength);

            event.target.value = trimmedValue;

            setInpVal((prevInpVal) => ({
                ...prevInpVal,
                mobile: trimmedValue
            }));

            if (trimmedValue.length !== expectedMobileLength) {
                setMobileErrorMessage(`Enter a valid ${expectedMobileLength}-digit mobile number`);
            } else {
                setMobileErrorMessage('');
                if (isAdmissionAuthEnabled === 2) {
                    checkTokenExists(trimmedValue);
                }
            }

        }
        if(name === 'token_input'){
            let token = value.trim()
            if(token.length !== 8){
                setTokenErrorMessage('Enter valid token')
            }else {
                setTokenErrorMessage('')
            }
        }
        if(name === 'email'){
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailRegex.test(value.trim())){
                setEmailErrorMessage('Enter a valid email');
            } else {
                setEmailErrorMessage('');
            }
        }


    }

    const handleClose = () => {
        setSnackbarOpen(false);
    };

    const handleCountryCodeChange = (event) => {
        const newCode = event.target.value;
        setSelectedCountryCode(newCode);
        setShowEmailOtpFallback(false);
        setShowEmailField(false);
        setOtpSource('mobile');

        const newCountry = countryCodeList.find(c => String(getCC(c)) === String(newCode));
        const newLength = newCountry ? getML(newCountry) : 10;

        const truncated = (inpVal.mobile || '').replace(/[^\d]/g, '').slice(0, newLength);
        setInpVal((prevInpVal) => ({ ...prevInpVal, mobile: truncated }));

        if (truncated.length === 0) {
            setMobileErrorMessage('');
        } else if (truncated.length !== newLength) {
            setMobileErrorMessage(`Enter a valid ${newLength}-digit mobile number`);
        } else {
            setMobileErrorMessage('');
        }
    };

    const checkTokenExists = async (mobileNumber) => {
        if (mobileNumber !== "") {
            let univId = univID ? univID : sessionStorage.getItem('univID')
            try {
                const response = await fetch(ValidateToken, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ mobileNo: mobileNumber, univId: univId,  token: "", action: "isExist" }),
                });
                if (response.ok) {
                    const data = await response.json();

                    if(data.data.isExist === 1 && data.data.isExpired === 0){
                        setTokenData(data.data)
                        setToken(data.data.token)
                    }else if(data.data.isExist === 1 && data.data.isExpired === 1){
                       setSnackbarMessage(data.message);
                        setSnackbarOpen(true);
                    }
                    
                } else {
                    console.log("otp not generated")
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        let timerId;
        if (isTimerRunning) {
          timerId = setInterval(() => {
            setCountdown((prevCountdown) => {
              if (prevCountdown > 0) {
                return prevCountdown - 1; // Decrease countdown by 1 second
              } else {
                clearInterval(timerId); // Clear the timer when countdown reaches 0
                setIsTimerRunning(false);
                return 0;
              }
            });
          }, 1000); // Update countdown every second
        }
        return () => {
          clearInterval(timerId);
        };
    }, [isTimerRunning]);

    // Validation to display otp block
    const showOtpField = async (source = 'mobile') => {
        const otpSourceArg = typeof source === 'string' ? source : 'mobile';
        setOtpSource(otpSourceArg);
        let univId = univID ? univID : sessionStorage.getItem('univID')

        const isEmailSource = otpSourceArg === 'email';

        if (inpVal.mobile.trim() === "") {
            setMobileErrorMessage('Mobile number is required');
        }
        if (isEmailSource && inpVal.email.trim() === "") {
            setEmailErrorMessage('Email is required');
        }
        if (inpVal.full_name.trim() === "") {
            setNameErrorMessage('Full name is required');
        } if (!selectedDate) {
            setDateErrorMessage('Date of birth is required')
        } if (captchaErrorMessage !== ''){
            setCaptchaErrorMessage('')
        }
        if (selectedDate) {
            const today = new Date();
            const birthDate = new Date(selectedDate);
            const yearsDiff = differenceInYears(today, birthDate);
            // setAge(yearsDiff);
            if (isNaN(yearsDiff)) {
                setDateErrorMessage('Invalid Date of birth');
            } else if (yearsDiff < 15) {
                setDateErrorMessage('You should be minimum 15 years old at the time of admission.');
            }
            else if (
                inpVal.full_name.trim() !== "" &&
                inpVal.mobile.trim() !== "" &&
                mobileErrorMessage === '' &&
                (!isEmailSource || (inpVal.email.trim() !== "" && emailErrorMessage === '')) &&
                selectedDate &&
                dateErrorMessage === '' &&
                nameErrorMessage === ''
            ) {
                setMobileErrorMessage('');
                setNameErrorMessage('');
                setEmailErrorMessage('');
                // setDateErrorMessage('')
                setCountdown(120);
                let block = document.getElementById('otpBlock');
                block.style.display = 'block';

                let timerBlock = document.getElementById('timer');
                timerBlock.style.display = 'block';
                // trigger api to generate otp
                try {
                    const response = await fetch(GenerateOtp, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            generateNew: tokenData?.isExist === 0 ? true : false ,
                            dateOfBirth: dob,
                            mobileNo,
                            name: inpVal.full_name,
                            univID: univId,
                            captchaFlag: captchaEnable,
                            refreshCaptchaFlag: isAdmissionAuthEnabled === 2 ? (sendOtpAttempt === 0 ? 0 : 1) : 0,
                            otpSource: isEmailSource ? 'email' : 'mobile',
                            email: isEmailSource ? inpVal.email.trim() : ''
                        }),
                    });
                    if (response.status === 200) {
                        const data = await response.json();
                        setOtpResponse(data.data)
                        setCaptchaDetails(data.data.captchaDetails)
                        setIsTimerRunning(true);
                        setCountdown(120);
                        setToken(data.data.token)
                        setSendOtpAttempt((prev) => prev + 1);
                        if (!isEmailSource) {
                            setShowEmailOtpFallback(false);
                        }
                    } else {
                        if (isIndia && !isEmailSource) {
                            setShowEmailOtpFallback(true);
                        }
                    }
                } catch (error) {
                    console.log(error);
                }

            }
        }

    }
    const minutes = String(Math.floor(countdown / 60)).padStart(2, '0');
    const seconds = String(countdown % 60).padStart(2, '0');

    const Navigate = useNavigate();
    // validation of otp 
    const validateOtp = async (otpVal) => {
        setOtp(parseInt(otpVal));
        if (otpVal.length < 4) {
            setOtpErrorMessage('OTP is required.');
        } else {
            setOtpErrorMessage('');
            // if (otpVal === 1111) {
            //     Navigate("/course-selection");
            // }
            // validate otp
            try {
                const response = await fetch(ValidateOtp, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ dateOfBirth: dob, mobileNo: mobileNo, otp: parseInt(otpVal), univID }),
                });
                if (response.ok) {
                    const data = await response.json();
                    setValidateOtpData(data)
                    
                    // setTempOtp(data.data)
                    if (data.isSuccess && captchaEnable === 0) {
                        // redirect
                        let block = document.getElementById('timer');
                        block.style.display = 'none';
                        sessionStorage.setItem("Action", "new");
                        Navigate("/course-selection");
                    } else if (data.isSuccess === false && captchaEnable === 0) {
                        setOtpErrorMessage(data.message)
                    } else if (data.isSuccess && captchaEnable === 1){
                        // setOtpVerified(true)
                        let block = document.getElementById('timer');
                        block.style.display = 'none';

                        let captchaBlock = document.getElementById('captcha_block')
                        captchaBlock.style.display = 'block'
                    }
                } else {
                    setOtpErrorMessage('Invalid OTP')
                }
            } catch (error) {
                console.log(error);
            }

            // Store data using session
            sessionStorage.setItem("name", inpVal.full_name);
            sessionStorage.setItem("mobileNo", inpVal.mobile);
            sessionStorage.setItem("email", inpVal.email);
            sessionStorage.setItem("countryCode", selectedCountryCode ? (String(selectedCountryCode).startsWith('+') ? selectedCountryCode : `+${selectedCountryCode}`) : '');
            sessionStorage.setItem("dateOfBirth", dob);
            // sessionStorage.setItem("univID",45);
            sessionStorage.setItem("loggedInUser", 'student');
            sessionStorage.setItem("source", "admission")

        }
    }

    const resendOtp = async () => {
        setOtpErrorMessage('');
        setTimeout(null)
        // setCountdown(120); // set countdown to 2 mintues

        // trigger api for generate otp
        try {
            const response = await fetch(GenerateOtp, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ dateOfBirth: dob, mobileNo, name: inpVal.full_name, univID, captchaFlag: captchaEnable, refreshCaptchaFlag: isAdmissionAuthEnabled === 2 ? 1 : 0, otpSource: otpSource, email: otpSource === 'email' ? inpVal.email.trim() : '' }),
            });

            if (response.ok) {
                const data = await response.json();
                setTempOtp(data.data)
                setIsTimerRunning(true);
                setCountdown(120);
                // const timer = setInterval(() => {
                //     setCountdown((prevCountdown) => {
                //         if (prevCountdown > 0) {
                //             return prevCountdown - 1; // Decrease countdown by 1 second
                //         } else {
                //             clearInterval(timer); // Clear the timer when countdown reaches 0
                //             setTimeout(1);  // set timeout to 1 to display resend button
                //             return 0;
                //         }
                //     });

                // }, 1000); // Update countdown every second

            } else {
                console.log("otp not generated")
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        let mobileNo = sessionStorage.getItem('mobileNo')
        let name = sessionStorage.getItem('name')
        let dob = sessionStorage.getItem('dateOfBirth')

        setInpVal((prevInpVal) => ({
            ...prevInpVal,
            full_name: name || '',
            mobile: mobileNo || '',
        }));

    }, [])

    const captureCaptcha = (event) => {
        setCaptchaValue(event.target.value)
    }

    const validateCaptcha = async () => {

        try {
            const response = await fetch(ValidateCaptcha, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ dateOfBirth: dob, mobileNo: mobileNo, captchaValue: captchaValue, univId: parseInt(sessionStorage.getItem('univID')) }),
            });
            if (response.ok) {
                const data = await response.json();
                if(data.isSuccess && validateOtpData && validateOtpData.isSuccess){
                    // setCaptchaVerified(true)
                    sessionStorage.setItem("Action", "new");
                    Navigate("/course-selection");
                } else if(data.isSuccess === false && data.data.captchaDetails.attempts === 0){
                    setOtp('')
                    setInpVal((prevInpVal) => ({
                        ...prevInpVal,
                        'mobile': ''
                    }));
                    setCaptchaValue('')

                    let captchaBlock = document.getElementById('captcha_block')
                    captchaBlock.style.display = 'none'

                    let block = document.getElementById('otpBlock');
                    block.style.display = 'none';

                    setMobileErrorMessage("Maximum attempts exceeded. Please request a new OTP to continue.")
                } else if(data.isSuccess && !validateOtpData ){
                    setOtpErrorMessage('OTP is required')
                } else {
                    setCaptchaErrorMessage(data.message)
                }
                
                // } else if (data.isSuccess === false && captchaEnable === 0) {
                    // setOtpErrorMessage(data.message)
                // }
            } else {
                setOtpErrorMessage('Invalid Captcha')
            }
        } catch (error) {
            console.log(error);
        }

    }

    const refreshCaptcha = async() => {
        try {
            const response = await fetch(GenerateOtp, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ dateOfBirth: dob, mobileNo, name: inpVal.full_name, univID, captchaFlag: captchaEnable, refreshCaptchaFlag: isAdmissionAuthEnabled === 2 ? 1 : 0, otpSource: otpSource, email: otpSource === 'email' ? inpVal.email.trim() : '' }),
            });
            if (response.ok) {
                const data = await response.json();
                setTempOtp(data.data)
                setCaptchaDetails(data.data.captchaDetails)
            } else {
                console.log("")
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleProceed = () => {
        if (inpVal.mobile.trim() === "") {
            setMobileErrorMessage('Mobile number is required');
        } if (inpVal.full_name.trim() === "") {
            setNameErrorMessage('Full name is required');
        } if (!selectedDate) {
            setDateErrorMessage('Date of birth is required')
        } if (captchaErrorMessage !== ''){
            setCaptchaErrorMessage('')
        }
        if (selectedDate) {
            const today = new Date();
            const birthDate = new Date(selectedDate);
            const yearsDiff = differenceInYears(today, birthDate);
            // setAge(yearsDiff);
            if (isNaN(yearsDiff)) {
                setDateErrorMessage('Invalid Date of birth');
            } else if (yearsDiff < 15) {
                setDateErrorMessage('You should be minimum 15 years old at the time of admission.');
            }
            else if (inpVal.full_name.trim() !== "" && inpVal.mobile.trim() !== "" && selectedDate && dateErrorMessage === '' && nameErrorMessage === '' && mobileErrorMessage === '') {
                sessionStorage.setItem("name", inpVal.full_name);
                sessionStorage.setItem("mobileNo", inpVal.mobile);
                sessionStorage.setItem("email", inpVal.email || '');
                sessionStorage.setItem("countryCode", selectedCountryCode ? (String(selectedCountryCode).startsWith('+') ? selectedCountryCode : `+${selectedCountryCode}`) : '');
                sessionStorage.setItem("dateOfBirth", dob);
                sessionStorage.setItem("loggedInUser", 'student');
                sessionStorage.setItem("source", "admission");
                sessionStorage.setItem("Action", "new");
                Navigate("/course-selection");
            }
        }
    }

    const handleCopy = () => {
        // Your copy logic here
        navigator.clipboard.writeText(token);
        setTooltipTitle('Copied!');   
    };

    const handleTokenSignIn = () => {
        document.getElementById('token_block').style.display = 'block';
    }

    const VerifyToken = async() => {
        // console.log('verify token')
        if (inpVal.mobile.trim() !== "" && inpVal.token_input.trim() !== "") {
            let univId = univID ? univID : sessionStorage.getItem('univID')
            try {
                const response = await fetch(ValidateToken, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ mobileNo: mobileNo, univId: univId,  token: inpVal.token_input, action: "isValidate" }),
                });
                if (response.ok) {
                    const data = await response.json();
                    setTokenValidationData(data.data)
                    // setTokenData(data.data)

                    if(data.data.isValidate === 1){
                        handleProceed()
                    } else {
                        setTokenErrorMessage(data.message)
                    }
                } else {
                    console.log("Token not verified")
                }
            } catch (error) {
                console.log(error);
            }
        }
    }


    return (
        <Grid item xs={12} sm={8} md={5} elevation={6} square>
            <Box sx={{ my: 8, mx: mobileView ? 4 : 10, direction: 'column', alignItems: 'center', justifyContent: "center" }}>
                <Box>
                    <Typography class="header" sx={{ textAlign: 'left', textTransform: 'none', fontWeight: 550 }} component="h1" variant="h6">
                        Thank you for showing interest
                    </Typography>
                    <Typography class="typography" sx={{ textAlign: 'left' }} mt={5}>
                        Register to complete the student application form
                    </Typography>
                    <Box component="form" noValidate sx={{ width: '87%' }}>
                        <InputLabel className='label' sx={{ mt: 3 }}>
                            Full name <span style={{color: 'red'}}>(Name as in SSC / X class marks memo)</span>
                        </InputLabel>
                        <TextField
                            className='inputRequired'
                            required
                            fullWidth
                            id="full_name"
                            name="full_name"
                            autoComplete="off"
                            onChange={check}
                            value={inpVal.full_name}
                            sx={{
                                input: {
                                    width: '100%',
                                    // border: '0.5px solid #2B4DC0',
                                    borderRadius: '4px',
                                    height: '11px',
                                    borderLeft: '2px solid red'
                                }
                            }}
                            inputProps={{
                                maxLength: 100
                            }}
                            helperText={
                                <Typography className={nameErrorMessage ? 'error' : ''} id='full_name_error'>
                                    {nameErrorMessage}
                                </Typography>
                            }
                        />

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <InputLabel className='label'> Date of birth </InputLabel>
                            <DemoContainer components={['DatePicker', 'TimePicker', 'DateTimePicker', 'DateRangePicker',]}>
                                <DemoItem sx={{ marginTop: '0px !important', border: '0.5px solid #2B4DC0', }} componentName="DatePicker" name="dob" valueType="date">
                                    <DatePicker
                                        sx={{
                                            marginTop: '0px !important',
                                            input: { borderLeft: '2px solid red', borderRadius: '4px', height: '11px' }
                                        }}
                                        className='inputRequired'
                                        id='dob'
                                        format='DD/MM/YYYY'
                                        name="dob"
                                        disableFuture
                                        maxDate={year}
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        // InputProps={{
                                        //     endAdornment: (
                                        //         <Typography>{age !== null ? `${age} years` : ''}</Typography>
                                        //     )
                                        // }}

                                    />
                                    <Typography className={dateErrorMessage ? 'error' : ''} id='dob_error'>
                                        {dateErrorMessage}
                                    </Typography>
                                </DemoItem>
                            </DemoContainer>
                        </LocalizationProvider>

                        <InputLabel className='label' sx={{ mt: 3 }}> Enter your mobile number </InputLabel>
                        <TextField
                            className="inputRequired"
                            value={inpVal.mobile}
                            type="text"  // Changed to text for better control over length
                            required
                            fullWidth
                            id="mobile"
                            name="mobile"
                            autoComplete="off"
                            inputRef={undefined}
                            ref={mobileFieldRef}
                            inputProps={{
                                maxLength: expectedMobileLength,
                                pattern: '[0-9]*',
                            }}
                            sx={{
                                input: { height: '11px', borderLeft: 'none !important' },
                                '& .MuiOutlinedInput-root': {
                                    borderLeft: '2px solid red',
                                    borderRadius: '4px'
                                }
                            }}
                            InputProps={{
                                startAdornment: countryCodeList.length > 0 ? (
                                    <InputAdornment position="start">
                                        <Select
                                            id="country_code"
                                            name="country_code"
                                            value={selectedCountryCode}
                                            onChange={handleCountryCodeChange}
                                            onOpen={() => {
                                                if (mobileFieldRef.current) {
                                                    setMobileFieldWidth(mobileFieldRef.current.getBoundingClientRect().width);
                                                }
                                            }}
                                            onClose={() => setCountrySearch('')}
                                            variant="standard"
                                            disableUnderline
                                            sx={{
                                                minWidth: 70,
                                                fontSize: '14px',
                                                '& .MuiSelect-select': { paddingRight: '20px !important', paddingLeft: '4px' }
                                            }}
                                            MenuProps={{
                                                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                                transformOrigin: { vertical: 'top', horizontal: 'left' },
                                                PaperProps: {
                                                    sx: {
                                                        maxHeight: 240,
                                                        width: mobileFieldWidth || 250,
                                                        mt: 1.8,
                                                        ml: -1.5,
                                                        '& .MuiMenuItem-root': {
                                                            fontSize: '13px',
                                                            minHeight: 'auto',
                                                            paddingTop: '6px',
                                                            paddingBottom: '6px'
                                                        }
                                                    }
                                                }
                                            }}
                                            renderValue={(value) => {
                                                const v = String(value || '');
                                                return v.startsWith('+') ? v : `+${v}`;
                                            }}
                                        >
                                            <ListSubheader sx={{ p: 1, backgroundColor: '#fff' }}>
                                                <TextField
                                                    autoFocus
                                                    fullWidth
                                                    size="small"
                                                    placeholder="Search country"
                                                    value={countrySearch}
                                                    onChange={(e) => setCountrySearch(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key !== 'Escape') {
                                                            e.stopPropagation();
                                                        }
                                                    }}
                                                    inputProps={{ sx: { fontSize: '13px', py: 0.75 } }}
                                                />
                                            </ListSubheader>
                                            {(() => {
                                                const q = countrySearch.trim().toLowerCase().replace(/^\+/, '');
                                                const scored = countryCodeList
                                                    .map((c) => {
                                                        const code = String(getCC(c)).toLowerCase().replace(/^\+/, '');
                                                        const name = String(getCN(c)).toLowerCase();
                                                        if (!q) return { c, rank: 5 };
                                                        if (code === q) return { c, rank: 0 };
                                                        if (code.startsWith(q)) return { c, rank: 1 };
                                                        if (name.startsWith(q)) return { c, rank: 2 };
                                                        if (name.includes(q)) return { c, rank: 3 };
                                                        if (code.includes(q)) return { c, rank: 4 };
                                                        return null;
                                                    })
                                                    .filter(Boolean)
                                                    .sort((a, b) => a.rank - b.rank);
                                                return scored.map(({ c }) => {
                                                    const code = String(getCC(c));
                                                    const display = code.startsWith('+') ? code : `+${code}`;
                                                    return (
                                                        <MenuItem key={code} value={code}>
                                                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
                                                                <span style={{ display: 'inline-block', width: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                                    {getCN(c) || ''}
                                                                </span>
                                                                <span>({display})</span>
                                                            </span>
                                                        </MenuItem>
                                                    );
                                                });
                                            })()}
                                        </Select>
                                    </InputAdornment>
                                ) : null,
                                endAdornment: (
                                    isAdmissionAuthEnabled === 1 && isIndia ? (
                                    <Button className="primary-btn" id="send_otp" sx={{ marginRight: '-3%', textTransform: 'none' }} variant="contained" onClick={() => showOtpField('mobile')}>
                                        Send OTP
                                    </Button>
                                    ) : null
                                )
                            }}
                            onChange={check}
                            helperText={
                                <Typography sx={{ ml: 0 }} className={mobileErrorMessage ? 'error' : ''} id="mobile_error">
                                    {mobileErrorMessage}
                                </Typography>
                            }
                        />
                        {isAdmissionAuthEnabled === 2 && isIndia ? (
                            <Button className="primary-btn" id="send_otp" sx={{ marginRight: '-3%',marginTop: '5%', textTransform: 'none', width: '100% !important', textTransform: 'none', display: 'block'}} variant="contained" onClick={() => showOtpField('mobile')}>
                                Send OTP
                            </Button>
                        ): null}

                        {isIndia && showEmailOtpFallback && !showEmailField && (
                            <HyperLink
                                component="button"
                                onClick={(e) => { e.preventDefault(); setShowEmailField(true); }}
                                underline="hover"
                                sx={{ display: 'block', mt: 2, textAlign: 'left', fontSize: '14px', cursor: 'pointer' }}
                            >
                                Send OTP via email
                            </HyperLink>
                        )}

                        {((!isIndia && selectedCountryCode !== '') || (isIndia && showEmailField)) && (
                            <>
                                <InputLabel className='label' sx={{ mt: 3 }}> Enter your email </InputLabel>
                                <TextField
                                    className="inputRequired"
                                    value={inpVal.email}
                                    type="email"
                                    required
                                    fullWidth
                                    id="email"
                                    name="email"
                                    autoComplete="off"
                                    sx={{
                                        input: { height: '11px', borderLeft: 'none !important' },
                                        '& .MuiOutlinedInput-root': {
                                            borderLeft: '2px solid red',
                                            borderRadius: '4px'
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: isAdmissionAuthEnabled === 0 ? null : (
                                            <Button className="primary-btn" id="send_otp_email" sx={{ marginRight: '-3%', textTransform: 'none' }} variant="contained" onClick={() => showOtpField('email')}>
                                                Send OTP
                                            </Button>
                                        )
                                    }}
                                    onChange={check}
                                    helperText={
                                        <Typography sx={{ ml: 0 }} className={emailErrorMessage ? 'error' : ''} id="email_error">
                                            {emailErrorMessage}
                                        </Typography>
                                    }
                                />
                            </>
                        )}

                        {(isAdmissionAuthEnabled === 1 || isAdmissionAuthEnabled === 2) &&
                            <Box id="otpBlock" sx={{ display: 'none' }}>
                                <InputLabel className='label' sx={{ mt: 3 }}>
                                    {otpSource === 'email' ? 'Enter OTP sent to your email' : 'Enter OTP sent to your mobile number'}
                                </InputLabel>

                                <OtpInput
                                    className='otpField'
                                    type='number'
                                    name='otp'
                                    value={otp}
                                    numInputs={4}
                                    renderSeparator={<span>&emsp;</span>}
                                    renderInput={(props) => <input {...props}
                                        style={{ width: '15%', height: '47px', textAlign: '-webkit-center' }}
                                    />}
                                    onChange={validateOtp}
                                />
                                <Typography sx={{ textAlign: 'left' }} id='timer' className={otpErrorMessage ? 'error' : ''}>
                                    {countdown === 0 ? (
                                        <React.Fragment>
                                            {otpErrorMessage}
                                            <Box sx={{ textAlign: 'left', display: 'inline' }} id='resend_otp'>
                                                <HyperLink component="button" underline="none" sx={{ textAlign: 'left', mt: 3 }} onClick={(e) => { e.preventDefault(); resendOtp(); }}>
                                                    Resend OTP
                                                </HyperLink>
                                            </Box>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {otpErrorMessage}
                                            <Box sx={{ display: 'inline' }} id='otp_timer'>
                                                <Typography className="label">Resend otp in <Typography sx={{ color: '#1976d2', display: 'inline' }}>{minutes}:{seconds}</Typography> </Typography>
                                            </Box>
                                        </React.Fragment>
                                    )}

                                </Typography>
                            </Box>
                        }

                        {isAdmissionAuthEnabled === 2 && token && otpSource !== 'email' && (
                            <Box>
                                <Typography className="label">Your token for future logins is:
                                    <span className="token" id="token">&nbsp;{token} 
                                        <Tooltip 
                                            className="copy-tooltip"
                                            title={tooltipTitle}
                                        >
                                            <IconButton >
                                                <ContentCopyIcon className="copy-icon" id="copy-icon" size="small" onClick={handleCopy} />
                                            </IconButton>
                                        </Tooltip>
                                    </span>
                                </Typography>
                            </Box>
                        )}
                        
                        { isAdmissionAuthEnabled === 2 && tokenData && tokenData.isExist === 1 && tokenData.isExpired === 0 ? (
                            <>
                                <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
                                    <Box sx={{ flex: 1, height: '1px', backgroundColor: '#ccc' }} />
                                    <Typography sx={{ mx: 2, color: 'grey', whiteSpace: 'nowrap' }}>OR</Typography>
                                    <Box sx={{ flex: 1, height: '1px', backgroundColor: '#ccc' }} />
                                </Box>
                                <Button className="primary-btn" id="proceed" sx={{ marginRight: '-3%', marginTop: '3%', width: '100% !important', textTransform: 'none', display: 'block' }} variant="contained" onClick={handleTokenSignIn}>
                                    Sign In with Token
                                </Button>
                            </>
                            ) : null
                        }

                        { isAdmissionAuthEnabled === 0 ? (
                            <Button className="primary-btn" id="proceed" sx={{ marginRight: '-3%', marginTop: '5%', width: '100% !important', textTransform: 'none', display: 'block' }} variant="contained" onClick={handleProceed}>
                                Proceed with Admission
                            </Button>
                            ) : null
                        }             

                        <Box id='token_block' sx={{display: 'none'}}>
                            <InputLabel className='label' sx={{ mt: 3 }}>
                                Enter token
                            </InputLabel>
                            <TextField
                                className='inputRequired'
                                required
                                fullWidth
                                id="token_input"
                                name="token_input"
                                autoComplete="off"
                                onChange={check}
                                value={inpVal.token_input}
                                sx={{
                                    input: {
                                        width: '100%',
                                        // border: '0.5px solid #2B4DC0',
                                        borderRadius: '4px',
                                        height: '11px',
                                        borderLeft: '2px solid red'
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        isAdmissionAuthEnabled === 1 || isAdmissionAuthEnabled === 2 ? (
                                        <Button className="primary-btn" id="verify_token" sx={{ marginRight: '-3%', textTransform: 'none' }} variant="contained" onClick={VerifyToken}>
                                            Verify Token
                                        </Button>
                                        ) : null
                                    )
                                }}
                                inputProps={{
                                    maxLength: 8
                                }}
                                helperText={
                                    <Typography className={tokenErrorMessage ? 'error' : ''} id='full_name_error'>
                                        {tokenErrorMessage}
                                    </Typography>
                                }
                            />
                        </Box>

                        <Box className='token-error-snackbar' sx={{ width: 500 }}>
                            {/* Your other UI code */}
                            <Snackbar
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                open={snackbarOpen}
                                onClose={handleClose}
                                message={snackbarMessage}
                                autoHideDuration={3000}
                                ContentProps={{
                                    sx: {
                                    backgroundColor: '#2b4dc0ab', // Your background color
                                    color: '#fff',                // Optional: set text color
                                    }
                                }}
                            />
                        </Box>

                        {captchaEnable === 1 && captchaDetails !== null &&
                            <Box id='captcha_block' sx={{display: 'none'}}>
                            <Box sx={{display: 'flex',}}>
                                <img src={captchaDetails.captchaImage} alt='captcha' style={{float: 'left', marginTop: '8px'}}/>
                                <RefreshIcon sx={{mt:2, ml:1}} onClick={refreshCaptcha}/>
                            </Box>
                            <TextField
                                className="inputRequired"
                                value={captchaValue}
                                type="text"  // Changed to text for better control over length
                                required
                                fullWidth
                                id="captcha"
                                name="captcha"
                                autoComplete="off"
                                inputProps={{
                                    maxLength: 10,         // Set max length for phone number input
                                    pattern: '[0-9]*',     // Ensure only numeric characters are allowed
                                }}
                                sx={{
                                    mt: 2,
                                    input: { height: '11px' }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <Button className="primary-btn" id="verify_captcha" sx={{ marginRight: '-3%', textTransform: 'none' }} variant="contained" onClick={validateCaptcha}>
                                            Verify Captcha
                                        </Button>
                                    )
                                }}
                                onChange={captureCaptcha}
                                helperText={
                                    <Typography sx={{ ml: 0 }} className={captchaErrorMessage ? 'error' : ''} id="captcha_error">
                                        {captchaErrorMessage}
                                    </Typography>
                                }
                            />
                            </Box>
                        }
                    </Box>
                </Box>
            </Box>
        </Grid>
    )
}